import {Box} from '@mui/material'
import {BalanceHeader} from "../features/BalanceHeader.tsx";
import {Gallery} from "../features/Gallery.tsx";
import {VideoEffects} from "../features/VideoEffects.tsx";
import {ImageEffects} from "../features/ImageEffects.tsx";
import {StartGenerationDrawer} from "../features/StartGenerationDrawer.tsx";
import {FullscreenPreview} from "../features/FullscreenPreview.tsx";
import {Payment} from "../features/Payment.tsx";
import {PopUp} from "../features/PopUp.tsx";


function MainPage() {
    return (
        <Box display={'flex'} flexDirection={'column'} height={'100%'} padding={'50px 0 0 0'} sx={{overflowY: 'scroll', overflowX: 'hidden'}}>
            <BalanceHeader/>
            <VideoEffects/>
            <ImageEffects/>
            <Gallery/>
            <StartGenerationDrawer />
            <FullscreenPreview/>
            <Payment/>
            <PopUp/>
        </Box>
    )
}

export default MainPage
